import React from "react";
import { styled } from "@mui/system";
import { CircularProgress } from "@mui/material";

interface AcceptButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  loading?: boolean;
  fullWidth?: boolean;
  variant?: "primary" | "secondary";
}

const StyledButton = styled("button")<{
  fullWidth: boolean;
  variant: "primary" | "secondary";
}>(({ fullWidth, variant }) => ({
  display: "flex",
  padding: "20px 16px",
  justifyContent: "center",
  alignItems: "center",
  gap: "8px",
  alignSelf: "stretch",
  borderRadius: "28px",
  background: variant === "primary" ? "#FC4C4C" : "#FFFFFF",
  color: variant === "primary" ? "#FFFFFF" : "#002035",
  border: variant === "primary" ? "none" : "1px solid #E5E7EB",
  outline: "none",
  cursor: "pointer",
  fontFamily: "Roobert",
  fontSize: "18px",
  fontStyle: "normal",
  fontWeight: 600,
  lineHeight: "22px",
  width: fullWidth ? "100%" : "auto",
  transition: "all 0.2s ease-in-out",

  "&:hover": {
    background: variant === "primary" ? "#E04343" : "#F9FAFB",
    transform: "translateY(-1px)",
    boxShadow: "0 4px 12px rgba(252, 76, 76, 0.25)",
  },

  "&:active": {
    transform: "translateY(0)",
  },

  "&:disabled": {
    background: "#D1D4D6",
    color: "#9CA3A8",
    cursor: "not-allowed",
    transform: "none",
    boxShadow: "none",
  },
}));

const ButtonContent = styled("span")({
  display: "flex",
  alignItems: "center",
  gap: "8px",
});

export const AcceptButton: React.FC<AcceptButtonProps> = ({
  children,
  onClick,
  disabled = false,
  loading = false,
  fullWidth = true,
  variant = "primary",
}) => {
  return (
    <StyledButton
      onClick={onClick}
      disabled={disabled || loading}
      fullWidth={fullWidth}
      variant={variant}>
      <ButtonContent>
        {loading ? <CircularProgress size={20} color="inherit" /> : children}
      </ButtonContent>
    </StyledButton>
  );
};

export default AcceptButton;
